/**
 * The one shape that says whether anything is wrong.
 *
 * Its own file because it is rendered in two places — the status page and the
 * admin header — and both have to be driven by the same verdict. A green dot
 * over a page listing three failures is worse than no dot: it teaches the
 * reader that the dot means nothing.
 */
export type Tone = 'ok' | 'busy' | 'warn'

const TONE: Record<Tone, string> = {
  ok: 'var(--mantine-color-gray-5)',
  busy: 'var(--mantine-color-green-6)',
  warn: 'var(--mantine-color-red-6)',
}

export default function StatusDot({ tone, size = 10 }: { tone: Tone; size?: number }) {
  return (
    <span
      aria-hidden
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        background: TONE[tone],
        flex: 'none',
      }}
    />
  )
}
